import React from 'react';

import type { PageLayoutOptionsWidth } from '@gitbook/hive-core';

export const PageLayoutWidthContext = React.createContext<PageLayoutOptionsWidth | undefined>(
    undefined
);

export function PageLayoutProvider(props: {
    children: React.ReactNode;
    width?: PageLayoutOptionsWidth;
}) {
    return (
        <PageLayoutWidthContext.Provider value={props.width}>
            {props.children}
        </PageLayoutWidthContext.Provider>
    );
}
